// extracted by mini-css-extract-plugin
module.exports = {"row":"NoteRow_row__wqdml","authorName":"NoteRow_authorName__1XSaw"};